/**
 * HC-UNREAD-COUNTER follow-up. Decides whether ChatRoomPage.js's
 * markConversationAsRead should re-fire for a new getMessages snapshot
 * emission, mirroring mobile's chat_room_screen.dart _previousMessageCount
 * guard exactly: don't re-fire on the first emission (that's just
 * establishing a baseline — the mount-time useEffect already marked as
 * read once), only re-fire when the message count has genuinely grown
 * since the last emission, never on an emission with the same or fewer
 * messages (an edited message re-emitting the snapshot, or an unrelated
 * re-render, must not re-fire).
 *
 * Pure — no React/Firestore dependency — so it's testable in isolation.
 * (This project's Jest setup can't currently resolve react-router-dom v7's
 * ESM-only build, so a full ChatRoomPage render test isn't possible here —
 * see ChatRoomPage.test.js's header comment.)
 *
 * @param {number} previousCount - message count from the last emission,
 *   or -1 if this is the first emission since the conversation mounted.
 * @param {number} newCount - message count in this emission.
 * @returns {{ shouldRefire: boolean, nextPreviousCount: number }}
 */
export function resolveMarkAsReadRefire(previousCount, newCount) {
  if (previousCount < 0) {
    return { shouldRefire: false, nextPreviousCount: newCount };
  }
  if (newCount > previousCount) {
    return { shouldRefire: true, nextPreviousCount: newCount };
  }
  return { shouldRefire: false, nextPreviousCount: previousCount };
}
